import { Paper } from "@mui/material";
import { styled } from "@mui/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import React from "react";

const StyledPaper = styled(Paper)(({ theme }: { theme: OLTheme }) => ({
  border: `1px solid ${theme.gray200}`,
  padding: theme.spacing(12),
  borderRadius: "8px",
  boxShadow: "0px 1px 1px rgba(154, 147, 147, 0.25)",
}));

const useStyles = makeStyles(() =>
  createStyles({
    noPadding: { padding: "0px" },
    noBorder: { border: 0, boxShadow: "none" },
  }),
);

interface OLPaperProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  noBorder?: boolean;
  "data-test-id"?: string;
}
export function OLPaper({
  children,
  className = "",
  noPadding,
  noBorder,
  "data-test-id": dataTestId,
}: OLPaperProps) {
  const classes = useStyles();

  return (
    <StyledPaper
      data-test-id={dataTestId}
      className={`${noBorder ? classes.noBorder : ""}  ${noPadding ? classes.noPadding : ""} ${className}`}
    >
      {children}
    </StyledPaper>
  );
}
